import styled from "styled-components";
import { deviceType } from "@tm/static/utils";

export const OrderDetailStyle = styled.div`
  padding-top: 36px;
  background: #f6f6f6;
  padding-bottom: 30px;
  @media ${deviceType.mobile} {
    padding-top: 60px;
  }
`;

export const OrderDetailWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const OrderDetailContent = styled.div`
  display: flex;
  gap: 18px;
  @media ${deviceType.mobile} {
    flex-direction: column;
    gap: 8px;
  }
`;

export const OrderDetailLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const OrderDetailRight = styled.div`
  flex-shrink: 0;
  width: 288px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;

export const OrderDetailMobileHd = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #fff;
`;

export const PageContainer = styled.div`
  background: #f2f2f2;
  padding: 30px;
  height: calc(100vh- 80px);
  @media ${deviceType.mobile} {
    padding: 16px;
  }
`;

export const PageGreyWrap = styled.div`
  width: 1200px;
  margin: 0 auto;
  background: #f2f2f2;
  height: calc(100vh - 80px);
  gap: 16px;
  display: flex;
  flex-direction: column;
  @media ${deviceType.mobile} {
    width: 100%;
  }
`;
